import { FaultUpdate } from '@eagle/data-function-types';
import React, { useMemo } from 'react';
import { useBatchDtcFaultDescriptions, useBatchDtcSourceDescriptions } from '../events-table/events-batch-fault.queries';
import { BatchFaultDataProvider } from './batch-fault-context';
import { useHistorySearch } from './use-history-search';

/**
 * Wrapper component that fetches batch fault data for all journey events
 * and provides it to both timeline and map views
 */
export const BatchFaultWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { eventData } = useHistorySearch();

  const allFaultEventsDataList = useMemo(() => {
    const allEvents: Array<{ eventData: FaultUpdate; thingId: string; eventId: string }> = [];
    eventData.forEach((journey) => {
      journey.data.items.forEach((event) => {
        if (event.data && 'code' in event.data) {
          allEvents.push({
            eventData: event.data as unknown as FaultUpdate,
            thingId: event.thingId,
            eventId: event.eventId,
          });
        }
      });
    });
    return allEvents;
  }, [eventData]);

  const { data: faultDescriptions = {}, isLoading: faultDescriptionsLoading } = useBatchDtcFaultDescriptions({ eventDataList: allFaultEventsDataList });
  const { data: sourceDescriptions = {}, isLoading: sourceDescriptionsLoading } = useBatchDtcSourceDescriptions({ eventDataList: allFaultEventsDataList });
  const isBatchFaultDataLoading = faultDescriptionsLoading || sourceDescriptionsLoading;

  return (
    <BatchFaultDataProvider
      faultDescriptions={faultDescriptions}
      sourceDescriptions={sourceDescriptions}
      isLoading={isBatchFaultDataLoading}
    >
      {children}
    </BatchFaultDataProvider>
  );
};
